var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 4.75C20.1383 4.75 5.25 19.6383 5.25 38C5.25 56.3617 20.1383 71.25 38.5 71.25C56.8617 71.25 71.75 56.3617 71.75 38C71.75 19.6383 56.8617 4.75 38.5 4.75ZM52.8613 27.1418L37.2309 48.8137C37.0124 49.1186 36.7244 49.367 36.3908 49.5384C36.0571 49.7098 35.6874 49.7992 35.3123 49.7992C34.9372 49.7992 34.5675 49.7098 34.2339 49.5384C33.9002 49.367 33.6122 49.1186 33.3938 48.8137L24.1387 35.9887C23.8566 35.5953 24.1387 35.0461 24.6211 35.0461H28.102C28.859 35.0461 29.5789 35.4098 30.0242 36.0332L35.3086 43.366L46.9758 27.1863C47.4211 26.5703 48.1336 26.1992 48.898 26.1992H52.3789C52.8613 26.1992 53.1434 26.7484 52.8613 27.1418Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.fb278951fe5da9697fa7ebd9716650fb.svg";
export { ForwardRef as ReactComponent };